
import Storages from '../helper/storages';
import Toast from './../components/toast'
function ErrorHandler(e) {
    console.log(e.response)

    switch (e?.response?.status) {
        case 421:
            Toast.Error(e.response.data.content)
            console.log('input params is missing 421', e.response.data.content)
            break;
        case 403:
            Toast.Error(e.response.data.content)
            console.log('access denied 403')
            break;
        case 401:
            setTimeout(() => {
                Toast.SessionEnd()
                Storages.setUserToken(undefined)
            }, 1000)
            console.log('login expired 401')
            break;
        case 404:
            Toast.Error(e.response.data.content)
            console.log('api not find 404')
            break;
        case 500:
            Toast.Error(e.response.contact)
            console.log('server error 500')
            break;
        default:
            Toast.Error(e?.response?.data?.content)
            console.log('error not defined ', e?.response?.status)
            break;
    }

    return (<></>)
}

export default ErrorHandler